import env from "../../../../../../config/env";
import "./index.css";
import toast from "react-hot-toast";
import { X } from "lucide-react";
import { Button } from "components/ui/button";
import { useDeleteTeamMember } from "../../../../../../queries/settingsAccount";

const Modal = ({ isOpen, onClose, children }) => {
  const BASE_URL = `${env.API_URL}/v1`;
  return (
    <>
      {isOpen && (
        <div className="modal-overlay" onClick={onClose}>
          <div
            className="modal-content-modal text-center bg-card"
            onClick={(e) => e.stopPropagation()}
          >
            {children}
          </div>
        </div>
      )}
    </>
  );
};

// Example usage in another component
const DeleteFileModal = ({ isModalOpen, justCloseIt, fileInfo, getLocationUsers }) => {
  const deleteTeamMemberMutation = useDeleteTeamMember();
  const deleteTeamMember = async () => {
    try {
      const data = await deleteTeamMemberMutation.mutateAsync(fileInfo._id);

      if (data.success) {
        toast.success("User deleted successfully");
        justCloseIt()
        getLocationUsers()
        return true;
      } else {
        toast.error(data.message);
        return false;
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      alert("An error occurred while deleting the user. Please try again.");
      return false;
    }
  };


  return (
    <div>
      <Modal isOpen={isModalOpen}>
        <div className="scrollable-modal-content position-relative" >

          <button
            type="button"
            aria-label="Close"
            className="absolute right-3 top-3 text-muted-foreground hover:text-foreground"
            onClick={justCloseIt}
          >
            <X className="w-4 h-4" />
          </button>


          <div style={{ marginBottom: "20px" }}>
            <span className="text-lg font-semibold text-foreground" >Delete Team Member</span>
          </div>

          <p className="text-sm text-muted-foreground" >
            Are you sure you want to delete this team member<br />
            This action cannot be undone.
          </p>

          <div className="modalBtnGroup">
            <Button type="submit" variant="destructive" onClick={deleteTeamMember}>
              Yes, delete team member
            </Button>

            <Button variant="outline" onClick={justCloseIt}>
              No, go back
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default DeleteFileModal;
